import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { Tagline } from "@/components/pro-blocks/landing-page/tagline"

export function FaqSection2() {
  return (
    <section className="bg-background section-padding-y border-b" aria-labelledby="faq-heading" id="faq">
      <div className="container-padding-x container mx-auto">
        <div className="flex flex-col gap-10 lg:flex-row lg:gap-16">
          {/* Left Column */}
          <div className="section-title-gap-lg flex flex-1 flex-col">
            {/* Category Tag */}
            <Tagline>FAQ</Tagline>
            {/* Main Title */}
            <h1 id="faq-heading" className="heading-lg text-foreground">
              Частые вопросы
            </h1>
            {/* Section Description */}
            <p className="text-muted-foreground">
              Не нашли ответ?{" "}
              <a href="mailto:hello@feedbackiq.io" className="text-primary underline">
                Напишите нам.
              </a>
            </p>
          </div>

          {/* Right Column */}
          <div className="flex flex-1 flex-col gap-8">
            {/* General FAQ Section */}
            <div className="flex flex-col gap-2">
              {/* Section Title */}
              <h2 className="text-foreground text-lg font-semibold md:text-xl">Настройка</h2>
              {/* FAQ Accordion */}
              <Accordion type="single" collapsible>
                {/* FAQ Item 1 */}
                <AccordionItem value="item-1">
                  <AccordionTrigger className="text-left">Сколько времени занимает настройка?</AccordionTrigger>
                  <AccordionContent>
                    Подключение занимает 5 минут. Вы входите через аккаунт вашей системы поддержки, разрешаете доступ на
                    чтение — и готово. Не нужно привлекать разработчиков.
                  </AccordionContent>
                </AccordionItem>

                {/* FAQ Item 2 */}
                <AccordionItem value="item-2">
                  <AccordionTrigger className="text-left">Насколько точно система понимает обращения?</AccordionTrigger>
                  <AccordionContent>
                    Точность автоматической категоризации — 90%. Это выше, чем при ручном анализе разными людьми (60%
                    консистентности). Система обучается на ваших корректировках.
                  </AccordionContent>
                </AccordionItem>

                {/* FAQ Item 3 */}
                <AccordionItem value="item-3">
                  <AccordionTrigger className="text-left">Нужно ли привлекать разработчиков?</AccordionTrigger>
                  <AccordionContent>
                    Нет. Весь процесс настройки выполняется через интерфейс, без программирования. Подключение через
                    стандартную авторизацию вашей системы поддержки.
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>

            {/* Billing FAQ Section */}
            <div className="flex flex-col gap-2">
              {/* Section Title */}
              <h2 className="text-foreground text-lg font-semibold md:text-xl">Безопасность и данные</h2>
              {/* FAQ Accordion */}
              <Accordion type="single" collapsible>
                {/* FAQ Item 1 */}
                <AccordionItem value="security-1">
                  <AccordionTrigger className="text-left">Безопасно ли давать доступ к обращениям?</AccordionTrigger>
                  <AccordionContent>
                    Да. Мы используем шифрование при передаче и хранении данных. Доступ только на чтение — мы не можем
                    изменять ваши обращения. Данные не используются для обучения общих моделей.
                  </AccordionContent>
                </AccordionItem>

                {/* FAQ Item 2 */}
                <AccordionItem value="security-2">
                  <AccordionTrigger className="text-left">Можно ли попробовать перед покупкой?</AccordionTrigger>
                  <AccordionContent>
                    Да. 14 дней бесплатно на любом тарифе. Полный функционал, никаких ограничений. Карта не требуется
                    для начала.
                  </AccordionContent>
                </AccordionItem>

                {/* FAQ Item 3 */}
                <AccordionItem value="security-3">
                  <AccordionTrigger className="text-left">Что если лимит обращений превышен?</AccordionTrigger>
                  <AccordionContent>
                    Мы предупредим заранее. Вы можете перейти на следующий тариф в любой момент. Мы не остановим работу
                    системы внезапно — анализ продолжится до конца месяца.
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
